module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "inp-input",
    class: {
      'error': _vm.error
    }
  }, [_c('input', {
    class: [{
        'input pl-2': !_vm.isBackgroundGrey
      },
      {
        'tw-cursor-default': _vm.disabled
      },
      {
        'tw-cursor-pointer': !_vm.disabled
      },
      {
        'tw-border tw-text-gray-500': _vm.disabled && !_vm.isBackgroundGrey
      },
      {
        'tw-rounded-t tw-border-b tw-px-1 tw-pb-0.5 tw-border-dashed tw-text-gray-500': _vm.isBackgroundGrey
      },
      _vm.label ? 'tw-pt-4' : 'tw-pt-0.5' ],
    attrs: {
      "type": "time",
      "required": _vm.required,
      "disabled": _vm.disabled,
      "placeholder": " "
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "focus": function($event) {
        _vm.focus($event)
      },
      "blur": function($event) {
        _vm.blur($event)
      },
      "paste": function($event) {
        _vm.paste($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tw-pointer-events-none\ttw-absolute tw-w-full tw-transition-all tw-duration-200 ellipsis tw-top-0 tw-text-sm tw-px-1 tw-mb"
  }, [_vm._v(_vm._s(_vm.label))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70d6fa04"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/InputTime/InputTime.vue.html
// module id = g74e
// module chunks = 2